import NetworkIndicator from './NetworkIndicator'

export default function Footer() {
  return (
    <footer className="w-full border-t border-slate-700/50 bg-slate-800/30 py-3 mt-8">
      <div className="w-full max-w-3xl mx-auto px-4 flex justify-between items-center">
        <span className="text-xs text-slate-500">PulseChain Sponsor Bot</span>
        <NetworkIndicator />
      </div>
    </footer>
  )
}

